import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const Style = styled(Modal)`
  .modal-content {
    border-radius: 10px;
  }
  .modal-dialog {
    max-width: 648px !important;
    min-height: 316px !important;
    width: 100% !important;
    @media (max-width: 768px) {
      width: auto !important;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 26px 35px 26px;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .wrapper {
    flex: 1;
    display: flex;
    justify-content: center;

    img {
      margin-right: 15px;
    }
  }

  span {
    color: #000fff;
    font-size: 1.5rem;
    font-family: "Mangueira Bold";
  }

  svg {
    color: #000fff;
    cursor: pointer;
  }
`;

export const Body = styled.div`
  h2 {
    color: #000fff;
    font-size: 1.5rem;
    line-height: 24px;
    text-align: left;
    margin-bottom: 25px;
    width: 100%;
    text-align: center;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-size: 1rem;
    line-height: 25px;
    margin-bottom: 0;

    @media only screen and (max-width: 500px) {
      text-align: center;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  padding: 0 35px;
  gap: 15px;

  > p {
    text-align: center;
    font-size: 0.9rem;
  }

  > svg {
    margin-right: 15px;
    flex-shrink: 0;

    @media only screen and (max-width: 500px) {
      margin-right: 0;
      margin-bottom: 15px;
    }
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: center;

  button:nth-child(2) {
    margin-left: 27px;
  }

  button {
    height: 50px;
    width: 50%;
  }
`;

export const Img = styled.img`
  height: 300px;
`;
